module.exports.init = function(config){

  var config = config || { debug: false };

  var active = typeof config.debug != 'undefined' && config.debug;

  return {
    active: active,
    log: function(message){
      if(active){
        if(typeof message == "object"){
          console.log("Creek: Object debug below: ");
          // console.log(message);
        }
        else{
          console.log("Creek: "+message);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/creek-debug.js